import moment from 'moment';
import _ from 'lodash';
import Hashids from 'hashids';
import { enqueueSnackbar } from 'notistack';
//
import config from '../config';
import { DEFAULT_DATE_FORMAT } from '../constants/reports';
import { WL_LIST_PAYMENT_WARNING_RANGE_DAYS } from '../constants';

export const escapeRegExp = (value) => {
  return value.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, '\\$&');
};

export const showErrorNotification = (text) =>
  enqueueSnackbar(text, { variant: 'error' });

export const handleApiError = (e, defaultMessage = 'Server error!') => {
  const errors = e?.data?.error || e?.response?.data?.error;

  console.log(errors);
  if (Array.isArray(errors)) {
    errors.forEach((err) => showErrorNotification(err));
  } else if (typeof errors === 'string') {
    showErrorNotification(errors);
  } else {
    showErrorNotification(
      e?.data?.message || e?.response?.data?.message || defaultMessage,
    );
  }
};

const { salt, ln, alphabet } = config.hashIds;
export const hashids = new Hashids(salt, ln, alphabet);

export const stringToBoolean = (stringValue) => {
  if (_.isBoolean(stringValue) || !_.isString(stringValue)) {
    return stringValue;
  }

  switch (stringValue.toLowerCase().trim()) {
    case 'true':
    case 'yes':
    case '1':
      return true;

    case 'false':
    case 'no':
    case '0':
    case 'null':
    case '':
    case 'undefined':
      return false;

    default:
      return JSON.parse(stringValue);
  }
};

export const randomString = (length) => {
  let result = '';
  const characters =
    'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const charactersLength = characters.length;
  for (let i = 0; i < length; i++) {
    result += characters.charAt(Math.floor(Math.random() * charactersLength));
  }
  return result;
};

export const mergeArrayOverwriteCustomizer = (oldValue, newValue) => {
  if (Array.isArray(newValue)) {
    return newValue;
  }
  return undefined;
};

export const getStartDate = () =>
  moment(new Date()).add(-6, 'days').format('YYYY-MM-DD');
export const getEndDate = () =>
  moment(new Date()).add(0, 'days').format('YYYY-MM-DD');

export const searchAnyFieldFilter = (query) => {
  const queryRegexp = new RegExp(escapeRegExp(query), 'i');
  return (item) =>
    Object.values(item).some(
      (fieldValue) => fieldValue && queryRegexp.test(fieldValue.toString()),
    );
};

export const formatRoleToLabel = (value) =>
  _.capitalize(value.replace(/_+/i, ' ').toLowerCase());

export const mapToLabels = (data) =>
  Object.entries(data).map(([value, label]) => ({ value, label }));

export const isNotificationDateIsDue = (dateStr) =>
  /^\d{4}-\d{1,2}-\d{1,2}$/.test(dateStr) &&
  !moment()
    .add(WL_LIST_PAYMENT_WARNING_RANGE_DAYS, 'days')
    .isBefore(moment(dateStr, DEFAULT_DATE_FORMAT.toUpperCase()), 'day');
